module.exports = __webpack_public_path__ + "img/mobile-sms.1b9d8e9c.png";